import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setEmbeddedConfig } from 'store/embeddingConfSlice';
import { IElementViewerVisibility } from 'store/elementViewerSlice';

export const EmbeddingContext = React.createContext<IEmbeddingContext>({
    wall: {},
    extLink: {},
    actionsBar: {},
    iNotification: {},
    iOpenExt: {},
    bookmark: {},
    segment: {},
    eFilters: {},
    chart: {},
});

export interface IEmbeddingContext {
    wall: { hide?: string };
    extLink: { hide?: string };
    actionsBar: { hide?: string };
    bookmark: { hide?: string };
    segment: { hide?: string };
    iNotification: { hide?: string };
    iOpenExt: { hide?: string };
    eFilters: { hide?: string };
    chart: { chart?: string };
}

const pref = '_ec_';

export function useSetupEmbeddingContext() {
    const dispatch = useDispatch();
    const urlParams = new URLSearchParams(window.location.search);
    const storeState = useSelector((state: any) => state.embeddingConf.data) as IEmbeddingContext;

    const iterate = (o: any) => {
        for (const [key, value] of Object.entries(o)) {
            if (typeof value == 'object') {
                iterate(value);
            } else {
                const p = `${pref}${o[key]}`;
                const pv = urlParams.get(p);
                o[key] = pv == null ? undefined : pv;
            }
        }
    };

    useEffect(() => {
        const paramsMap: IEmbeddingContext = {
            wall: { hide: 'wall' },
            extLink: { hide: 'extLink' },
            actionsBar: { hide: 'actionsBar' },
            iNotification: { hide: 'iNotification' },
            iOpenExt: { hide: 'iOpenExt' },
            bookmark: { hide: 'bookmark' },
            segment: { hide: 'segment' },
            eFilters: { hide: 'eFilters' },
            chart: { chart: 'chart' },
        };
        iterate(paramsMap);
        if (window.location.search.includes(pref)) {
            dispatch(
                setEmbeddedConfig({
                    newState: paramsMap,
                }),
            );
        }
    }, []);

    return storeState;
}

export function useEmbeddingContextVisible(element: string) {
    const embeddingContext = useContext(EmbeddingContext);
    const isApp = useSelector((state: any) => state.elementViewer?.isApp);
    const visibility = useSelector((state: any) => state.elementViewer?.visibility);

    if (isApp && visibility && element) {
        if (element.includes('.')) {
            const keys = element.split('.');
            let value: any = visibility;
            for (const key of keys) {
                if (value && typeof value === 'object' && key in value) {
                    value = value[key];
                } else {
                    return true;
                }
            }
            return value !== false;
        } else if (element in visibility) {
            return visibility[element] !== false;
        }
    }

    //@ts-ignore
    return !(embeddingContext?.[element]?.hide == '1');
}
